<template>
  <div>
    <v-container>
      <v-layout justify-center>
        <v-flex fluid>

          <v-card>

            <v-toolbar card class="secondary">
              <v-icon>description</v-icon>
            </v-toolbar>

            <v-data-table :headers="headers" :items="items" item-key="filename" :loading="loading" :rows-per-page-items="[10,20,50]">
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.year }}</td>
                  <td class="text-xs-center">{{ props.item.month }}</td>
                  <td>{{ props.item.reptype }}</td>
                  <td class="text-xs-center">
                    <v-btn small flat icon color="primary" @click="downloadFile(props.item)">
                      <v-icon small>save_alt</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'reports',
  data: () => ({
    headers: [
      { text: 'Year', value: 'year', width: '1%', sortable: false },
      { text: 'Month', value: 'month', width: '1%', align: 'center', sortable: false },
      { text: 'Report Type', value: 'reptype', sortable: false },
      { text: 'Actions', sortable: false, align: 'center', width: '15%' }
    ],
    items: [],
    loading: false,
    load_error: ''
  }),
  methods: {
    populateTable: function () {
      this.items = []
      this.loading = true

      let url = '/reports'
      if (this.$store.getters.auth_user == 'admin') {
        url += '/' + this.account_code
      }
      this.$api.get(url).then(response => {
        this.items = response.data.slice()
        this.loading = false
      }).catch(e => {
        this.loading = false
        if (!e.response) {
          this.load_error = 'No response from API server.'
        } else {
          this.load_error = 'Error loading report list (error ' + e.response.status + ')'
        }
      })
    },
    downloadFile: function (item) {
      this.$api.get('/repdownload/' + this.account_code + '/' + item.filename,{ responseType: 'arraybuffer' }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download','report.'+item.fext)
        document.body.appendChild(link)
        link.click()
      })
    }
  },
  computed: {
    account_code: function () {
      if (this.$store.getters.auth_user === 'admin') {
        return this.$store.state.admin_selacc
      }
      //return this.$store.getters.auth_data['account_code']
      return this.$store.getters.auth_user
    }
  },
  watch: {
    account_code: function () {
      this.populateTable()
    }
  },
  beforeMount: function () {
    this.populateTable()
  }
}
</script>

<style scoped>
</style>
